import './App.css';
// import { Route, Routes } from 'react-router-dom'
import Home from './components/Home';
import Myself from './components/Myself';
import Projects from './components/Projects';
import Credits from './components/Credits';
import SideContact from './components/SideContact';


function App() {
  return (
    <div className="App">
      <div>
        <Home />
        <Myself />
        <Projects />
        <Credits />
      </div>
      <SideContact />
    </div>
  );
}

export default App;
